<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getFinishGoodQualityInspectInboxs"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Control Card" id="filter-" size="sm" :model.sync="filter.controlCardId" @input="getControlCards" @focus="getControlCards" />
					<app-input-textbox id="fieldset-qty-before" label-cols-sm="4" label-cols-lg="3" label="Qty Before" label-for="filter-qty-before" size="sm" :model.sync="filter.qtyBefore" />
					<app-input-textbox id="fieldset-qty-after" label-cols-sm="4" label-cols-lg="3" label="Qty After" label-for="filter-qty-after" size="sm" :model.sync="filter.qtyAfter" />
					<app-input-textbox id="fieldset-qty-pending" label-cols-sm="4" label-cols-lg="3" label="Qty Pending" label-for="filter-qty-pending" size="sm" :model.sync="filter.qtyPending" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-qty-ng" label-cols-sm="4" label-cols-lg="3" label="Qty Ng" label-for="filter-qty-ng" size="sm" :model.sync="filter.qtyNg" />
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part" id="filter-" size="sm" :model.sync="filter.partId" @input="getParts" @focus="getParts" />
					<app-input-combobox-autocomplete :options="workOrderProcessDetails" optionsLabel="part" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Work Order Process Detail" id="filter-" size="sm" :model.sync="filter.workOrderProcessDetailId" @input="getWorkOrderProcessDetails" @focus="getWorkOrderProcessDetails" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getFinishGoodQualityInspectInboxs"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Finish Good Quality Inspect Inbox</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown v-if="true" text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="/files/FinishGoodQualityInspectInbox/FinishGoodQualityInspectInbox.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button v-if="true" class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
					
					<b-overlay v-if="isShowDeleteButton"
							   :show="isDeleteBusy"
							   rounded
							   opacity="0.6"
							   spinner-small
							   spinner-variant="primary"
							   class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-finishgoodqualityinspectinbox" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="finishGoodQualityInspectInboxs" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="finishGoodQualityInspectInboxs.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="Control Card" class="table-filter">
					<v-select append-to-body label="controlCardNumber" :options="controlCards" :value="filter.controlCardId" :reduce="item => item.id" v-model="filter.controlCardId" :filterable="true" @input="getFinishGoodQualityInspectInboxsWithoutLoading" @search="getControlCards"></v-select>
				</b-th>
				<b-th stacked-heading="Qty Before" class="table-filter">
					<b-form-input id="input-qty-before-table" @input="getFinishGoodQualityInspectInboxsWithoutLoading" v-model="filter.qtyBefore" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty After" class="table-filter">
					<b-form-input id="input-qty-after-table" @input="getFinishGoodQualityInspectInboxsWithoutLoading" v-model="filter.qtyAfter" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Pending" class="table-filter">
					<b-form-input id="input-qty-pending-table" @input="getFinishGoodQualityInspectInboxsWithoutLoading" v-model="filter.qtyPending" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Ng" class="table-filter">
					<b-form-input id="input-qty-ng-table" @input="getFinishGoodQualityInspectInboxsWithoutLoading" v-model="filter.qtyNg" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Metode Qc" class="table-filter">
					<v-select append-to-body label="name" :options="metodeQcs" :value="filter.metodeQcId" :reduce="item => item.id" v-model="filter.metodeQcId" :filterable="true" @input="getFinishGoodQualityInspectInboxsWithoutLoading" @search="getMetodeQcs"></v-select>
				</b-th>
				<b-th stacked-heading="Part" class="table-filter">
					<v-select append-to-body label="partNumber" :options="parts" :value="filter.partId" :reduce="item => item.id" v-model="filter.partId" :filterable="true" @input="getFinishGoodQualityInspectInboxsWithoutLoading" @search="getParts"></v-select>
				</b-th>
				<b-th stacked-heading="Work Order Process Detail" class="table-filter">
					<v-select append-to-body label="part" :options="workOrderProcessDetails" :value="filter.workOrderProcessDetailId" :reduce="item => item.id" v-model="filter.workOrderProcessDetailId" :filterable="true" @input="getFinishGoodQualityInspectInboxsWithoutLoading" @search="getWorkOrderProcessDetails"></v-select>
				</b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(controlcard)="row">

                <a @click="() => ( $router.push({ name: 'finishgoodqualityinspectinboxdetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.controlCard.controlCardNumber != null && row.item.controlCard.controlCardNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.controlCard.controlCardNumber.slice(0, 30) + (row.item.controlCard.controlCardNumber.length > 30 ? "..." : "" ) : row.item.controlCard.controlCardNumber : "" }}
						</a>
            
					</template>

			<template v-slot:cell(metodeQc)="row">
				{{ row.item.metodeQc != null ? row.item.metodeQc.name : "" }}
			</template>
			<template v-slot:cell(part)="row">
				{{ row.item.part != null ? row.item.part.partNumber : "" }}
			</template>
			<template v-slot:cell(workOrderProcessDetail)="row">
				{{ row.item.workOrderProcessDetail != null ? row.item.workOrderProcessDetail.part : "" }}
			</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2" v-if="isShowDeleteButton">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textbox id="fieldset-qty-after" label-cols-lg="12"  label="Qty After" label-for="input-qty-after" size="sm" :model.sync="row.item.qtyAfter"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-pending" label-cols-lg="12"  label="Qty Pending" label-for="input-qty-pending" size="sm" :model.sync="row.item.qtyPending"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-ng" label-cols-lg="12"  label="Qty Ng" label-for="input-qty-ng" size="sm" :model.sync="row.item.qtyNg"   :isEditable="false" :isUpdatable="true" />
						<app-input-radio :options="metodeQcs" text-field="name" value-field="id" label-cols-lg="12" label="Metode Qc" id="fieldset-metode-qc" size="sm" :model.sync="row.item.metodeQcId"   :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="partNumber" label-cols-sm="12" :model="row.item.partId" label="Part" :selected="row.item.part != null ? row.item.part.partNumber : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="part" label-cols-sm="12" :model="row.item.workOrderProcessDetailId" label="Work Order Process Detail" :selected="row.item.workOrderProcessDetail != null ? row.item.workOrderProcessDetail.part : ''" :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(finishGoodQualityInspectInboxsPaging != null ? finishGoodQualityInspectInboxsPaging.dataCount : 0)"
									:per-page="(finishGoodQualityInspectInboxsPaging != null ? finishGoodQualityInspectInboxsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-finishgoodqualityinspectinbox.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-finishgoodqualityinspectinbox.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import FinishGoodQualityInspectInbox from '@/models/FinishGoodQualityInspectInbox/FinishGoodQualityInspectInbox';
import FinishGoodQualityInspectInboxList from '@/models/FinishGoodQualityInspectInbox/FinishGoodQualityInspectInboxList';
import FinishGoodQualityInspectInboxFilter from '@/filters/FinishGoodQualityInspectInbox/FinishGoodQualityInspectInboxFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputRadio from '@/components/AppInputRadio';
import MetodeQcFilter from '@/filters/MetodeQc/MetodeQcFilter';
import MetodeQc from '@/models/MetodeQc/MetodeQc';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import ProblemCategoryFilter from '@/filters/ProblemCategory/ProblemCategoryFilter';
import ProblemCategory from '@/models/ProblemCategory/ProblemCategory';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		FinishGoodQualityInspectInbox, 
		FinishGoodQualityInspectInboxList, 
		FinishGoodQualityInspectInboxFilter, 
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		AppInputRadio,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"controlCard": {}, "class" : "th-control-card first-child", "label" : "Control Card", key: 'controlCard', sortable: true}, 
				{"qtyBefore": {}, "class" : "th-qty-before", "label" : "Qty Before", key: 'qtyBefore', sortable: true}, 
				{"qtyAfter": {}, "class" : "th-qty-after last-child", "label" : "Qty After", key: 'qtyAfter', sortable: true}, 
				{"qtyPending": {}, "class" : "th-qty-pending d-stack-none", "label" : "Qty Pending", key: 'qtyPending', sortable: true}, 
				{"qtyNg": {}, "class" : "th-qty-ng d-stack-none", "label" : "Qty Ng", key: 'qtyNg', sortable: true}, 
				{"metodeQc": {}, "class" : "th-metode-qc d-stack-none", "label" : "Metode Qc", key: 'metodeQc', sortable: true}, 
				{"part": {}, "class" : "th-part d-stack-none", "label" : "Part", key: 'part', sortable: true}, 
				{"workOrderProcessDetail": {}, "class" : "th-work-order-process-detail d-stack-none", "label" : "Work Order Process Detail", key: 'workOrderProcessDetail', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			finishGoodQualityInspectInboxs: [],
			finishGoodQualityInspectInboxsPaging: {},
			controlCards : [],
			parts : [],
			workOrderProcessDetails : [],
			finishGoodQualityInspectNgInboxs : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
			
		}
	},	methods : {
		getFinishGoodQualityInspectInboxs : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			FinishGoodQualityInspectInbox.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.finishGoodQualityInspectInboxs = result.data
					this.finishGoodQualityInspectInboxsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getFinishGoodQualityInspectInboxsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			FinishGoodQualityInspectInbox.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.finishGoodQualityInspectInboxs = result.data
					this.finishGoodQualityInspectInboxsPaging = result
				}
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			awaitControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		getMetodeQcs : async function(input) {
			let filter = new MetodeQcFilter();
			if (input != undefined) {
				filter.name = input;
			}
			awaitMetodeQc.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.metodeQcs = result.data
				}
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			awaitPart.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		getWorkOrderProcessDetails : async function(input) {
			let filter = new WorkOrderProcessDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			awaitWorkOrderProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcessDetails = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new FinishGoodQualityInspectInboxFilter();
			this.getFinishGoodQualityInspectInboxs();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getFinishGoodQualityInspectInboxs();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				FinishGoodQualityInspectInbox.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			FinishGoodQualityInspectInbox.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			FinishGoodQualityInspectInbox.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			FinishGoodQualityInspectInbox.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'finishgoodqualityinspectinboxedit';
						if(this.isScannerMode) {
							createRoute = 'finishgoodqualityinspectinboxscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			FinishGoodQualityInspectInbox.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'finishgoodqualityinspectinboxedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			FinishGoodQualityInspectInbox.deleteData(this, id).then(result => {
				if (result)
				{
					this.getFinishGoodQualityInspectInboxs();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				FinishGoodQualityInspectInbox.deleteMultipleData(this).then(result => {
					this.getFinishGoodQualityInspectInboxs();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableFinishGoodQualityInspectInboxParent = document.getElementById('table-list-finishgoodqualityinspectinbox').parentNode;
			tableFinishGoodQualityInspectInboxParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableFinishGoodQualityInspectInboxParent.scrollWidth - tableFinishGoodQualityInspectInboxParent.offsetWidth) == Math.ceil(tableFinishGoodQualityInspectInboxParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableFinishGoodQualityInspectInboxParent = document.getElementById('table-list-finishgoodqualityinspectinbox').parentNode;
			tableFinishGoodQualityInspectInboxParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableFinishGoodQualityInspectInboxParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new FinishGoodQualityInspectInboxFilter();
		// this.getControlCards()
		// this.getMetodeQcs()
		// this.getParts()
		// this.getWorkOrderProcessDetails()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Finish Good Quality Inspect Inbox"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getFinishGoodQualityInspectInboxs();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getFinishGoodQualityInspectInboxs();
			}
		},
		sortDesc: {
			handler: function() {
				this.getFinishGoodQualityInspectInboxs();
			}
		},
		currentPage: {
			handler: function() {
				this.getFinishGoodQualityInspectInboxs();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getFinishGoodQualityInspectInboxs();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				FinishGoodQualityInspectInbox.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "finishgoodqualityinspectinboxindex") {
					this.getFinishGoodQualityInspectInboxsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "finish_good_quality_inspect_inbox").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
